import authAxiosInstance from "../../authAxiosInstance";


export const articleFavouriteToggle = async (articleId) => {
    try {
        const response = await authAxiosInstance.post(`/mindpalace/favourite/${articleId}/`);
        return response.data;
    } catch (error) {
        console.error('Error toggling article favourite:', error);
        return [];
    }
};